module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00593.5cdb3e4b.jpg";